import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getRegulationsStagesPlanWorksMaterials(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS]
			.GET_REGULATIONS_STAGES_PLAN_WORKS_MATERIALS,
		options
	)
}
function _getRegulationsStagesPlanWorksMaterialPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS]
			.GET_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL_PREVIEW,
		options
	)
}
function _getRegulationsStagesPlanWorksMaterialPopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS]
			.GET_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL_POPUP,
		options
	)
}

function _createRegulationsStagesPlanWorksMaterial(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS]
			.CREATE_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL,
		options
	)
}

function _getRegulationsStagesPlanWorksMaterial(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS]
			.GET_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL,
		options
	)
}

function _patchRegulationsStagesPlanWorksMaterial(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS]
			.PATCH_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL,
		options
	)
}

function _putRegulationsStagesPlanWorksMaterial(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS]
			.PUT_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL,
		options
	)
}

function _deleteRegulationsStagesPlanWorksMaterial(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS]
			.DELETE_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_MATERIALS]: _getRegulationsStagesPlanWorksMaterials,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL_PREVIEW]: _getRegulationsStagesPlanWorksMaterialPreview,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL_POPUP]: _getRegulationsStagesPlanWorksMaterialPopup,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS]
		.CREATE_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL]: _createRegulationsStagesPlanWorksMaterial,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL]: _getRegulationsStagesPlanWorksMaterial,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS]
		.PATCH_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL]: _patchRegulationsStagesPlanWorksMaterial,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS]
		.PUT_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL]: _putRegulationsStagesPlanWorksMaterial,
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS]
		.DELETE_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL]: _deleteRegulationsStagesPlanWorksMaterial,
}
